import React, {useMemo} from 'react';
import {Input, Dropdown} from 'semantic-ui-react';

export const Filter = ({column}) => {
  return (
    <div>
      {column.canFilter && column.render('Filter')}
    </div>
  );
};

export const DefaultColumnFilter = ({
  'column': {
    filterValue,
    setFilter,
  },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || null);
      }}
    />
  );
};

const documentTypesOptions = [
  {'key': 0, 'text': 'TODOS', 'value': 'TODOS'},
  {'key': 1, 'text': 'FACTURA', 'value': 'FC'},
  {'key': 2, 'text': 'NOTA DE CRÉDITO', 'value': 'DC'},
];

const invoiceTypesOptions = [
  {'key': 0, 'text': 'TODOS', 'value': 'TODOS'},
  {'key': 1, 'text': 'REPUESTOS', 'value': 'CPD'},
  {'key': 2, 'text': 'LUBRICANTES', 'value': 'LBR'},
  {'key': 3, 'text': 'LOGISTICA', 'value': 'LOG'},
  {'key': 4, 'text': 'DISPOSITIVO SATELITAL', 'value': 'DIS'},
];

function selectOptions(options) {
  const isDocumentType = options.some((element) => element === 'FC' || element === 'FD');
  return isDocumentType ? documentTypesOptions : invoiceTypesOptions;
}

export const SelectColumnFilter = ({
  'column': {filterValue, setFilter, preFilteredRows, id},
}) => {
  const options = useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <Dropdown
      className='filter-selection'
      selection
      defaultValue='TODOS'
      value={filterValue}
      options={selectOptions(options)}
      onChange={(e, {value}) => {
        const currentValue = value !== 'TODOS' ? value : null;
        setFilter(currentValue);
      }}
    />
  );
};
